import { Text, View } from 'react-native'

import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const HelperTextContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: theme.spacingInlineOnepulse,
      backgroundColor: 'transparent',
      paddingHorizontal: theme.paddingInsetOnepulse,
      paddingTop: theme.spacingInlineHalfpulse,
    },
  }
})

export const HelperText = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreepulse,
      fontFamily: theme.fontFamily.semiBold,
      color: theme.colorTextNeutralAlternative,
      flexShrink: 1,
      width: '100%',

      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),

      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      isError: {
        true: {
          color: theme.colorTextDangerAlternative,
        },
      },
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      isReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isError: true,
          isDisabled: false,
          isReadOnly: false,
        },
        css: {
          color: theme.colorTextDangerAlternative,
        },
      },
      {
        variants: {
          isError: false,
          isDisabled: true,
          isReadOnly: false,
        },
        css: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      {
        variants: {
          isError: false,
          isDisabled: false,
          isReadOnly: true,
        },
        css: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    ],
  }
})
